// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Whether a button's command takes a FLOOR, so the monitoring panel knows to
 * render the floor-button strip rather than a single button.
 *
 * Derived server-side from `keys.floors_based` on the adapter key that carries
 * the bound command — the same key lookup `ActionScope` uses.
 *
 * WHY THIS IS NOT A BOOLEAN, and why it does not read `messages.position`.
 * `keys.floors_based` is NOT NULL DEFAULT false, so the column alone cannot
 * distinguish "this command does not take a floor" from "nobody ever populated
 * this adapter". UNKNOWN carries that difference: it means no key matched, or
 * the adapter's flags are degenerate, and a consumer must fall back to its own
 * classifier rather than demote. Demoting on a bad guess HIDES the floor
 * buttons an operator uses to recall a car with someone inside, so the
 * asymmetry is deliberate.
 *
 * The previous signal, `messages.position`, could not do this job: on a real
 * site it is true on 76 of 80 message rows, including both `CarToLobby` and
 * `IndependentService`, so it promoted almost everything to a floor strip.
 */
export enum ActionFloorScope {
  UNKNOWN = 0,

  /**
   * The bound command takes a floor — render the floor strip.
   */
  FLOOR = 1,

  /**
   * The bound command does not take a floor — render one plain button.
   */
  NO_FLOOR = 2,
}
